import { render, staticRenderFns } from "./ForecastUploader.vue?vue&type=template&id=472565be&scoped=true"
import script from "./ForecastUploader.vue?vue&type=script&lang=js"
export * from "./ForecastUploader.vue?vue&type=script&lang=js"
import style0 from "./ForecastUploader.vue?vue&type=style&index=0&id=472565be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472565be",
  null
  
)

export default component.exports